// The API read pointer is asynchronous. Keep the highest acknowledgement made
// in this browser session so a fast close/reopen cannot briefly restore an
// already-read chat to an older server pointer.
const acknowledgedReadIds = new Map();

const normalizeId = (value) => {
  const id = Number(value || 0);
  return Number.isFinite(id) && id > 0 ? id : 0;
};

const keyFor = (messagesBaseUrl) => String(messagesBaseUrl || "").trim();

export function rememberChatRead(messagesBaseUrl, messageId) {
  const key = keyFor(messagesBaseUrl);
  const id = normalizeId(messageId);
  if (!key || !id) return 0;

  const next = Math.max(normalizeId(acknowledgedReadIds.get(key)), id);
  acknowledgedReadIds.set(key, next);
  return next;
}

export function reconcileChatReadPosition(messagesBaseUrl, meta) {
  const key = keyFor(messagesBaseUrl);
  const localReadId = normalizeId(acknowledgedReadIds.get(key));
  const serverReadId = normalizeId(meta?.last_read_message_id);
  const lastMessageId = normalizeId(meta?.last_message_id);

  if (!localReadId || localReadId <= serverReadId) return meta;

  const effectiveReadId = lastMessageId
    ? Math.min(localReadId, lastMessageId)
    : localReadId;
  const caughtUp = Boolean(lastMessageId && effectiveReadId >= lastMessageId);

  return {
    ...meta,
    last_read_message_id: effectiveReadId,
    // The server's first-unread pointer can belong to the pre-ack snapshot.
    // Position from the known local read point until the server catches up.
    first_unread_message_id: 0,
    unread_count: caughtUp ? 0 : Number(meta?.unread_count || 0),
  };
}

export function __resetChatReadPositionForTests() {
  acknowledgedReadIds.clear();
}
